export const defaultRegistryUrl = 'https://api.anaconda.org/package/';
export const datasource = 'conda';
